var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.186,
    height: 64.787,
    viewBox: "0 0 70.186 64.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-business",
    "data-name": "Icon ionic-md-business",
    d: "M39.312,18.892V4.5H3.375V69.287H73.561v-50.4ZM17.75,62.083H10.562v-7.2H17.75Zm0-14.392H10.562v-7.2H17.75Zm0-14.392H10.562V26.1H17.75Zm0-14.408H10.562v-7.2H17.75ZM32.124,62.083H24.937v-7.2h7.187Zm0-14.392H24.937v-7.2h7.187Zm0-14.392H24.937V26.1h7.187Zm0-14.408H24.937v-7.2h7.187ZM66.374,62.083H39.312v-7.2H46.5V47.691H39.312v-7.2H46.5v-7.2H39.312V26.1H66.374ZM60.03,33.3H52.843v7.2H60.03Zm0,14.392H52.843v7.2H60.03Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#e61f2a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon-business.d0267983.svg";
export { ForwardRef as ReactComponent };